import { type SxProps } from '@mui/material'

export const StyledCard: SxProps = {
  width: '100%',
  '&:hover': {
    backgroundColor: '#1e90ff',
    cursor: 'pointer'
  }
}

export const StyledStack: SxProps = {
  position: 'absolute',
  zIndex: 1,
  flex: '1',
  width: '18.5%',
  '.MuiDialog-root &': {
    width: '75%'
  }
}

export const StyledCircularProgress: SxProps = {
  display: 'flex',
  justifyContent: 'center'
}
